"use client"

import { Localized } from "@/i18n/client"
import Image from "next/image"
import Link from "next/link"

import { BrandLogo } from "@/components/site/brand-logo"
import type { HeaderContent } from "@/content/types"
import { useSiteMediaUrl } from "@/cms/site-images-client"
import styles from "./site-header.module.css"
import { LanguageSwitcher } from "@/i18n/language-switcher"

type SiteHeaderProps = {
  content: HeaderContent
  onMenuOpen: () => void
  onAccountOpen: () => void
}

export function SiteHeader({
  content,
  onMenuOpen,
  onAccountOpen,
}: SiteHeaderProps) {
  const mediaUrl = useSiteMediaUrl()
  return <Localized>{(
    <header className={`${styles.scope} danaro-header`}>
      <button
        type="button"
        className="danaro-header-menu danaro-focus-ring"
        aria-label={content.menuLabel}
        onClick={onMenuOpen}
      >
        <Image
          src={mediaUrl("menu")}
          alt=""
          width={24}
          height={24}
          style={{ aspectRatio: "1" }}
          unoptimized
          className="danaro-header-icon"
        />
        <span>{content.menuLabel}</span>
      </button>

      <Link className="danaro-header-logo danaro-focus-ring" href="/" aria-label={content.homeLabel}>
        <BrandLogo preload animated />
      </Link>

      <div className="danaro-header-actions">
        <LanguageSwitcher />
        <button
          type="button"
          className="danaro-header-account danaro-focus-ring"
          aria-label={content.accountLabel}
          onClick={onAccountOpen}
        >
          <Image
            src={mediaUrl("accountIcon")}
            alt=""
            width={24}
            height={24}
            style={{ aspectRatio: "1" }}
            unoptimized
            className="danaro-header-icon"
          />
        </button>
      </div>
    </header>
  )}</Localized>
}
